import {Component, Input, OnInit} from '@angular/core';
import {FitMedProfile} from '@models/data/fit-med-profile/FitMedProfile';
import {hasValue} from '@shared/utils/helpers';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { GenderComponent } from '../../../../components/gender/gender.component';

import { ProfilePictureComponent } from '../../../../components/profile-picture/profile-picture.component';

@Component({
    selector: 'app-ed-fit-med-profile-extrasmall',
    templateUrl: './ed-fit-med-profile-extrasmall.component.html',
    styleUrls: ['./ed-fit-med-profile-extrasmall.component.scss'],
    standalone: true,
    imports: [ProfilePictureComponent, GenderComponent, LocalizedDatePipe]
})
export class EdFitMedProfileExtrasmallComponent implements OnInit {
  fitMedProfileId: string = null;
  fullName: string = null;
  subtitle: string = null;

  fitMedProfileValue: FitMedProfile = null;

  @Input() set fitMedProfile(content: FitMedProfile) {
    if (hasValue(content)) {
      this.fitMedProfileValue = content;
      this.fullName = content?.firstName + ' ' + content?.lastName;
      this.fitMedProfileId = content.id;
    }
  }

  ngOnInit(): void {
  }
}
